import Reveal from "./Reveal";
import { MATRUM_APP_URL } from "../config";
import MatrumWord from "./MatrumWord";
import { BookOpen, Video, Users, Sparkles } from "lucide-react";

const features = [
  { icon: BookOpen, title: "Información de confianza", desc: "Contenidos rigurosos y cercanos según tu etapa." },
  { icon: Video, title: "Cursos y sesiones en vivo", desc: "Aprende y resuelve dudas en directo, a tu ritmo." },
  { icon: Users, title: "Comunidad de mujeres", desc: "Conecta con otras mujeres que viven tu mismo momento." },
  { icon: Sparkles, title: "Suscripción por etapa", desc: "Embarazo, puerperio o menopausia: elige la tuya." },
];

export default function Matrum() {
  return (
    <section id="matrum" data-testid="matrum-community-section" className="py-24 md:py-32 bg-ciruela relative overflow-hidden">
      <div className="pointer-events-none absolute -top-32 -right-24 h-96 w-96 rounded-full bg-terracota/30 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 -left-24 h-80 w-80 rounded-full bg-rosa/20 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <h2 className="font-serif font-light text-5xl md:text-6xl text-crema leading-[1.05] tracking-tight">
            La comunidad <MatrumWord className="text-ambar text-6xl md:text-7xl" />
          </h2>
          <p className="font-body text-lg text-crema/85 mt-7 leading-relaxed max-w-xl">
            He creado <MatrumWord className="text-ambar text-2xl" />, una comunidad donde encontrarás
            información, y mediante suscripción, acceso a cursos, sesiones en vivo y una comunidad de
            mujeres acompañándose según la etapa en la que se encuentren.
          </p>

          <div className="grid sm:grid-cols-2 gap-5 mt-10">
            {features.map((f) => (
              <div key={f.title} className="flex items-start gap-4">
                <div className="h-11 w-11 rounded-xl bg-crema/10 flex items-center justify-center text-ambar shrink-0">
                  <f.icon className="h-5 w-5" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-sans font-medium text-crema text-[15px]">{f.title}</p>
                  <p className="font-body text-sm text-crema/70 mt-1 leading-snug">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <a
            href={MATRUM_APP_URL}
            data-testid="matrum-cta"
            className="inline-flex items-center gap-1.5 mt-11 font-sans font-medium rounded-full bg-terracota text-crema px-8 py-4 hover:bg-terracota-dark transition-colors duration-300"
          >
            Quiero formar parte de <MatrumWord className="text-2xl" />
          </a>
        </Reveal>

        <Reveal delay={150}>
          <div className="relative rounded-[40px] overflow-hidden border border-crema/15 shadow-2xl">
            <img
              src="/brand/matrum-community.png"
              alt="Comunidad de mujeres de todas las edades"
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ciruela/40 to-transparent" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
